<template>
  <div class="shadow border-bottom">
    <div>
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toolbar',
  components: {},
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
